// Pure comparison between the lines sent to checkFinalPrice and the rebuilt
// cart items. Lines without a price (or missing from the response) and the
// warranties of those products are not retained; they are reported as
// removed so a caller can confirm before the cart is updated.
const isWarrantyLine = product =>
  product.IsExtendedWarranty || product.WarrantyProductId != null

export const getCartPriceChanges = (allProducts, cartItems) => {
  const lineKey = p => p.LineNum ?? p.ProductId
  const pricedIds = new Set(
    cartItems
      .filter(item => !isWarrantyLine(item.product) && item.product?.Price)
      .map(item => item.product.ProductId)
  )
  const retainedItems = cartItems.filter(
    ({ product }) =>
      product.Price &&
      (!isWarrantyLine(product) || pricedIds.has(product.WarrantyProductId))
  )
  const retainedKeys = new Set(
    retainedItems.map(({ product }) => lineKey(product))
  )
  const removedProducts = allProducts.filter(
    product => !retainedKeys.has(lineKey(product))
  )
  return { retainedItems, removedProducts }
}
